var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Card, Text } from '@philips-internal/oswald-ui-components';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { ReactComponent as Checked } from '../../assets/images/global/check-circle.svg';
import { ReactComponent as Clock } from '../../assets/images/global/pending.svg';
import { ReactComponent as Gain } from '../../assets/images/global/movement-up.svg';
import { ReactComponent as Loss } from '../../assets/images/global/movement-down.svg';
import { IntakesOutputsAPI } from '.';
import moment from 'moment';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import './intakes-output-card.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
let IntakesOutputsCard = class IntakesOutputsCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { onClick, recordDate, description, descriptionType, gainLoss, professionalName, releaseDate, sequenceNumber } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        description,
                        descriptionType,
                        gainLoss,
                        professionalName,
                        recordDate,
                        releaseDate,
                        sequenceNumber
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    renderIcon(gainLoss) {
        if (gainLoss === 'G') {
            return React.createElement(Gain, null);
        }
        return React.createElement(Loss, null);
    }
    renderStatusIcon(releaseDate) {
        if (releaseDate) {
            return React.createElement(Checked, null);
        }
        return React.createElement(Clock, null);
    }
    renderData() {
        const { gainLoss, recordDate, descriptionType, professionalName, releaseDate } = this.props;
        const icon = this.renderIcon(String(gainLoss));
        const statusIcon = this.renderStatusIcon(releaseDate);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'c-intakes-output-content-item', onClick: () => this.handleClick() },
                React.createElement("div", { className: 'c-intakes-output-content-icon' }, statusIcon),
                React.createElement("div", { className: 'c-intakes-output-content' },
                    React.createElement(Text, { className: "c-title-value", value: descriptionType }),
                    React.createElement(Text, { className: "c-text-value", value: moment(recordDate).format('L LT') }),
                    React.createElement(Text, { className: "c-text-value", value: professionalName })),
                React.createElement("div", { className: 'c-intakes-output-content-icon' }, icon))));
    }
    render() {
        const legends = [
            {
                color: 'signal-gray-60',
                icon: React.createElement(Gain, null),
                label: MessageService.translate('tws.label-intake'),
                value: MessageService.translate('tws.label-intake'),
            },
            {
                color: 'signal-gray-60',
                icon: React.createElement(Loss, null),
                label: MessageService.translate('tws.label-output'),
                value: MessageService.translate('tws.label-output')
            },
            {
                color: 'signal-blue-45',
                icon: React.createElement(Clock, null),
                label: MessageService.translate('value-description.vital-sign.status.pending-release'),
                value: MessageService.translate('value-description.vital-sign.status.pending-release')
            },
            {
                color: 'signal-yellow-45',
                icon: React.createElement(Checked, null),
                label: MessageService.translate('text.finished'),
                value: MessageService.translate('text.finished')
            },
        ];
        const { sequenceNumber } = this.props;
        return (React.createElement(Card, { className: 'c-intakes-output-main', uuid: generateUUID(), width: 12, key: sequenceNumber, selectionType: SelectionType.SINGLE, superscription: legends },
            React.createElement("div", { className: 'c-intakes-output__wrapper' }, this.renderData())));
    }
};
IntakesOutputsCard = __decorate([
    AwesomeComponent({ api: IntakesOutputsAPI, type: ComponentType.DATA_DISPLAY })
], IntakesOutputsCard);
export default IntakesOutputsCard;
//# sourceMappingURL=intakes-outputs-card.js.map